import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import CartReducer from "./CartReducer";
const rootReducer = combineReducers({
    userAuth: AuthReducer,
    cartData: CartReducer,
});
export default rootReducer;
